import { forwardRef, useImperativeHandle } from "react";
import Collapse from "@/components/specific/Collapsable";

const CorporateManagementFAQ = forwardRef((props, ref) => {
  const faqItems = [
    {
      key: "1",
      header: "How do I manage team members?",
      content: `Team management includes:
        1. Adding new team members
        2. Setting role permissions
        3. Managing access levels
        4. Updating team information
        5. Removing team members`,
    },
    {
      key: "2",
      header: "What are the different corporate roles available?",
      content: `Available roles include:
        - Super Admin
        - Campaign Manager
        - Event Admin
        - Finance Admin
        - Communication Manager
        - Canvasser
        - Volunteer`,
    },
    {
      key: "3",
      header: "How do I update corporate information?",
      content: `To update corporate information:
        1. Go to Settings
        2. Select "Manage Organization"
        3. Choose "Corporate Info"
        4. Update necessary fields
        5. Save changes`,
    },
    {
      key: "4",
      header: "How does billing and subscription work?",
      content: `Billing and subscription features:
        - Monthly/annual billing cycles
        - Subscription plan management
        - Payment method updates
        - Invoice history
        - Usage tracking`,
    },
    {
      key: "5",
      header: "What security measures are in place?",
      content: `Security features include:
        - Two-factor authentication
        - Role-based access control
        - Activity logging
        - Data encryption
        - Regular security audits`,
    },
  ];

  useImperativeHandle(ref, () => ({
    handleContactSupport: async () => {
      window.location.href = "mailto:support@example.com";
    },
  }));

  return (
    <div className="mt-10">
      <Collapse items={faqItems} />
    </div>
  );
});

CorporateManagementFAQ.displayName = "CorporateManagementFAQ";

export default CorporateManagementFAQ;
